<script>
	import { onMount, createEventDispatcher, beforeUpdate, afterUpdate } from 'svelte';
	import { db, time, isPlaying, playerLoaded, soundAlarm, hashtag } from '../stores.js';
	// let answer;
	let tracks = [];
	let tweet = '';
	let twitter;
	let player;
	// let playerLoaded = false;
	let tracksLoaded = false;
	let isAudioPlayingNow = false;
	// let hashtag;

	let trackArtist;
	let trackTitle;


	const dispatch = createEventDispatcher();
	const cheer = new Audio('/cheer.mp3');
	const whistle = new Audio('/backtoworkwhistle.mp3');


	onMount( async() => {

		// $db.collection("data").doc("status")
		// 	.onSnapshot((doc) => {
		// 		console.log("current data!: ", doc.data());
		// 		hashtag = doc.data().hashtag;
		// 	});


		/////////////////////////////////////////////////

		// Check to see if there are already tracks in local storage
		if (!localStorage.getItem('tracks')){
			getTracks();
		} else {
			// See if they are up-to-date by local storage date and if more than 7 days
			const updated = localStorage.getItem('updated');
			if (!updated || (Date.now() >= +updated+(7*86400000))){
				getTracks();
			} else {
				// console.log('no need to update tracks');
				loadTracks();
			}
		}

		// Check to see if there are already social in local storage
		if (!localStorage.getItem('twitter')){
			getSocial();
		} else {
			// See if they are up-to-date by local storage date and if more than 7 days
			const updated = localStorage.getItem('updated');
			if (!updated || (Date.now() >= +updated+(7*86400000))){
				getSocial();
			} else {
				// console.log('no need to update social');
			}
		}

		/////////////////////////////////////////////////////


		// // See if there is a lastTrackPlayed item in local storage and split playlist and
		// // start tracks from next track.
		// const lastTrackPlayed = JSON.parse(localStorage.getItem('lastTrackPlayed'));
		// // console.log('lastTrackPlayed: ', lastTrackPlayed);
		// const pendingTracks = JSON.parse(localStorage.getItem('tracks'));
		// if (lastTrackPlayed){
		// 	// console.log('inside lastTrackPlayed if statement!: ',lastTrackPlayed);
		// 	// find index of lastTrackPlayed in the playlist
		// 	const indexMatch = (element) => element.id === lastTrackPlayed.id;
		// 	let playlistPosition = pendingTracks.findIndex(indexMatch);
		// 	// console.log('playlistPosition:',playlistPosition)
		// 	// check if playlistPosition + 1 is at the end, 
		// 	// if so, don't do anything, playlist will start at beginning automatically
		// 	// if not, split the tracks at playlistPosition + 1 and switch segments
		// 	if (playlistPosition + 1 < pendingTracks.length){
		// 		const firstSegment = pendingTracks.slice(0,playlistPosition+1);
		// 		const secondSegment = pendingTracks.slice(playlistPosition+1);
		// 		// console.log('firstSegment, secondSegment: ', firstSegment, secondSegment);
		// 		// setTracks([...secondSegment,...firstSegment]);
		// 		localStorage.setItem('tracks', JSON.stringify([...secondSegment,...firstSegment]));
		// 	}
		// }


		// tracks = JSON.parse(localStorage.getItem('tracks'));
		// twitter = JSON.parse(localStorage.getItem('twitter'));
		// // console.log('Audioplayer tracks: ',tracks);
		// // console.log('Audioplayer twitter: ',twitter);

	});


	///////////////////////////////////////////////////////////

	// set tracks
	function loadTracks(){
		// See if there is a lastTrackPlayed item in local storage and split playlist and
		// start tracks from next track.
		const lastTrackPlayed = JSON.parse(localStorage.getItem('lastTrackPlayed'));
		// console.log('lastTrackPlayed: ', lastTrackPlayed);
		const pendingTracks = JSON.parse(localStorage.getItem('tracks'));
		if (lastTrackPlayed){
			// console.log('inside lastTrackPlayed if statement!: ',lastTrackPlayed);
			// find index of lastTrackPlayed in the playlist
			const indexMatch = (element) => element.id === lastTrackPlayed.id;
			let playlistPosition = pendingTracks.findIndex(indexMatch);
			// console.log('playlistPosition:',playlistPosition)
			// check if playlistPosition + 1 is at the end, 
			// if so, don't do anything, playlist will start at beginning automatically
			// if not, split the tracks at playlistPosition + 1 and switch segments
			if (playlistPosition + 1 < pendingTracks.length){
				const firstSegment = pendingTracks.slice(0,playlistPosition+1);
				const secondSegment = pendingTracks.slice(playlistPosition+1);
				// console.log('firstSegment, secondSegment: ', firstSegment, secondSegment);
				// setTracks([...secondSegment,...firstSegment]);
				localStorage.setItem('tracks', JSON.stringify([...secondSegment,...firstSegment]));
			}
		}


		tracks = JSON.parse(localStorage.getItem('tracks'));
		twitter = JSON.parse(localStorage.getItem('twitter'));
		tracksLoaded = true;
		console.log('tracks loaded!');

		// console.log('Audioplayer tracks: ',tracks);
		// console.log('Audioplayer twitter: ',twitter);

	}

	// pull tracks from API	
	function getTracks(){
		fetch("https://us-central1-chillhop-v2.cloudfunctions.net/getActiveTracks")
			.then((response) => {
			// console.log("response: ", response);
			return response.json();
			})
			.then(async (data) => {
			// console.log(data.tracks[0].id);
			// console.log("data.tracks: ", data.tracks);
			// let tracksShuffled = shuffle(data.tracks);
			shuffle(data.tracks);
			// console.log('tracksShuffled: ', data.tracks);
			setTracks(data.tracks);
			// console.log('tracksShuffled: ', tracksShuffled);
			// bandcampPlayerElement.playlist = data.tracks;
			// await bandcampPlayerElement.loadPlayer();
			// tracks = { `${data.tracks[0].id}`: data.tracks[0] };
			// console.log("tracks: ", Object.fromEntries(data.tracks));
		});
	}

	// shuffle tracks
	function shuffle(array) {
		// console.log('shuffle tracks: ',array)
		let currentIndex = array.length,
		temporaryValue,
		randomIndex;
		// While there remain elements to shuffle...
		while (0 !== currentIndex) {
			// Pick a remaining element...
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;
			// And swap it with the current element.
			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex] = temporaryValue;
		}
		return array;
	}

	// set tracks and updated date in local storage 

	function setTracks(tracks){
		// console.log('setTracks');
		localStorage.setItem('tracks', JSON.stringify(tracks));
		localStorage.setItem('updated', JSON.stringify(Date.now()));
		loadTracks();
	}

	// get social accounts for artists
	function getSocial(){
		// console.log('getSocial');
		fetch("https://firestore.googleapis.com/v1/projects/chillhop-v2/databases/(default)/documents/social/accounts/")
		.then((response) => {
			// console.log("response: ", response);
			return response.json();
			})
			.then(async (data) => {
				// console.log('social data: ', data);
				setSocial(data.fields.twitter.mapValue.fields);
			});
	}

	function setSocial(accounts){
		// console.log('setSocial');
		localStorage.setItem('twitter', JSON.stringify(accounts));
		localStorage.setItem('updated', JSON.stringify(Date.now()));
	}
	
	////////////////////////////////////////////////////////////////////

	function sayHello() {
		dispatch('bob', {
			text: 'Hello!'
		});
	}

	function changeMode() {
		dispatch('mode', {
			text: 'home'
		});
	}

	function playAudio() {
		// console.log('playAudio: ',player);
		player.playAudio();
	}


	function handleTrackChanged(event) {
		// console.log('audioplayer trackchanged: ',event.detail);
		//Set the lastPlayed track
		localStorage.setItem('lastTrackPlayed', JSON.stringify(event.detail));
		trackArtist = twitter[event.detail.username].stringValue;
		trackTitle = event.detail.title;
		// tweet = `<a href="https://twitter.com/intent/tweet?hashtags=WorkinOnIt,${hashtag},HIPHOP,CODE,HIPHOPandCODE&text=Just heard ${twitter[event.detail.username].stringValue} - ${event.detail.title} at https://untilit.works (a @lifelongdev project)" target="_blank">Tweet</a>`;
	}

	function handleAudioPaused(event) {
		// console.log('audio paused: ', event);
		isAudioPlayingNow = false;
		isPlaying.update(n=>n=false);
	}


	function handleAudioPlaying(event) {
		// console.log('audio is playing: ', event);
		isAudioPlayingNow = true;
		isPlaying.update(n=>n=true);
	}

	function handlePlayerLoaded(event) {
		// console.log('player loaded: ', event);
		// playerLoaded = true;
		playerLoaded.update(n=>n=true);
	}

	beforeUpdate(() => {
		if (isAudioPlayingNow !== $isPlaying){
			// player.playAudio();
			isAudioPlayingNow = $isPlaying;
		}
		if (!$isPlaying && $soundAlarm !== 'none' ){
			// console.log('SOUND THE ALARM!!');
			if ($soundAlarm === 'whistle'){
				whistle.play();
			}
			if ($soundAlarm === 'cheer'){
				cheer.play();
			}
			soundAlarm.update(n=>n='none');
		}
	});

	afterUpdate(() => {
	});



</script>

<div id="container">
	<span id="player" class:loaded={$playerLoaded}>
		{#if !$playerLoaded}
			Loading Player
		{/if}
		{#if tracksLoaded}
			<bandcamp-player bind:this={player} playlist={tracks} on:trackChanged={handleTrackChanged} on:audioPaused={handleAudioPaused} on:audioPlaying={handleAudioPlaying} on:playerLoaded={handlePlayerLoaded}></bandcamp-player>
		{/if}

		<div id="corner-bl"></div>
		<div id="corner-tr"></div>
		<div id="twitter-container">
			Like the track? Help spread the word:
			<span id="twitter-info">
				<!-- {@html tweet} -->
				<a id="tweet-link" href="https://twitter.com/intent/tweet?hashtags=WorkinOnIt,{$hashtag},HIPHOP,CODE,HIPHOPandCODE&text=Just heard {trackArtist} - {trackTitle} at https://untilit.works (a @lifelongdev project)" target="_blank">Tweet</a>
			</span>
		</div>
	</span>
</div>

<!-- <button on:click={playAudio}>
	play
</button> -->
	
<style>
	:root {
		--player-bg-color: #ffffff;
		--player-gap: 15px;
	}

	#container {
		background-color: var(--player-bg-color);
		width: 75vw;
		max-width: 500px;
		height: 150px;
		position: relative;
	}

	#player {
		background-color: var(--player-bg-color);
		/*   background-color: transparent; */
		width: 75vw;
		max-width: 500px;
		height: 150px;
		position: absolute;
		left: 0;
		/*   transform: translate(var(--player-gap), var(--player-gap)); */
	}

	#corner-bl {
		width: 0;
		height: 0;
		border-left: var(--player-gap) solid transparent;
		border-right: 0px solid transparent;
		border-top: var(--player-gap) solid var(--player-bg-color);
		position: absolute;
		bottom: 1px;
		left: calc(-1 * var(--player-gap));
	}

	#corner-tr {
		width: 0;
		height: 0;
		border-left: 0px solid transparent;
		border-right: var(--player-gap) solid transparent;
		border-bottom: var(--player-gap) solid var(--player-bg-color);
		position: absolute;
		top: calc(-1 * var(--player-gap));
		right: 0px;
	}

	#player.loaded {
		animation: 1s ease-in 0s normal forwards slidein;
	}

	@keyframes slidein {
		from {
			transform: translate(0, 0);
		}
		to {
			transform: translate(var(--player-gap), var(--player-gap));
		}
	}

	#twitter-container {
		position: absolute;
		bottom: 0;
		width: 100%;
	}

	#tweet-link {
		color: rgb(0,100,200);
	}

</style>
